import type { CdropdownAlign } from "./Cdropdown.types";
import { CDROPDOWN_ALIGN, DROPDOWN_TRANSFORM_ORIGIN } from "./constants";

const TRANSFORM_ORIGIN_DIRECTION = {
  Up: "up",
  Down: "down",
} as const;

type TransformOriginDirection =
  (typeof TRANSFORM_ORIGIN_DIRECTION)[keyof typeof TRANSFORM_ORIGIN_DIRECTION];

const TRANSFORM_ORIGIN_BY_ALIGN_AND_DIRECTION: Record<
  CdropdownAlign,
  Record<TransformOriginDirection, string>
> = {
  [CDROPDOWN_ALIGN.Left]: {
    [TRANSFORM_ORIGIN_DIRECTION.Up]: DROPDOWN_TRANSFORM_ORIGIN.BottomLeft,
    [TRANSFORM_ORIGIN_DIRECTION.Down]: DROPDOWN_TRANSFORM_ORIGIN.TopLeft,
  },
  [CDROPDOWN_ALIGN.Right]: {
    [TRANSFORM_ORIGIN_DIRECTION.Up]: DROPDOWN_TRANSFORM_ORIGIN.BottomRight,
    [TRANSFORM_ORIGIN_DIRECTION.Down]: DROPDOWN_TRANSFORM_ORIGIN.TopRight,
  },
  [CDROPDOWN_ALIGN.Center]: {
    [TRANSFORM_ORIGIN_DIRECTION.Up]: DROPDOWN_TRANSFORM_ORIGIN.BottomCenter,
    [TRANSFORM_ORIGIN_DIRECTION.Down]: DROPDOWN_TRANSFORM_ORIGIN.TopCenter,
  },
};

export function resolveDropdownTransformOrigin(input: {
  align: CdropdownAlign;
  opensUpwards: boolean;
}): string {
  const direction = input.opensUpwards
    ? TRANSFORM_ORIGIN_DIRECTION.Up
    : TRANSFORM_ORIGIN_DIRECTION.Down;

  return TRANSFORM_ORIGIN_BY_ALIGN_AND_DIRECTION[input.align][direction];
}
